export const TRANSLATE_PARENT_REQUEST = 'TRANSLATE_PARENT_REQUEST';
export const TRANSLATE_PARENT_SUCCESS = 'TRANSLATE_PARENT_SUCCESS';
export const TRANSLATE_PARENT_FAILURE = 'TRANSLATE_PARENT_FAILURE';

export const TRANSLATE_CHILD_REQUEST = 'TRANSLATE_CHILD_REQUEST';
export const TRANSLATE_CHILD_SUCCESS = 'TRANSLATE_CHILD_SUCCESS';
export const TRANSLATE_CHILD_FAILURE = 'TRANSLATE_CHILD_FAILURE';

export const TOGGLE_PARENT_TRANSLATION = 'TOGGLE_PARENT_TRANSLATION';
export const TOGGLE_CHILD_TRANSLATION = 'TOGGLE_CHILD_TRANSLATION';

export const translateParentRequest = (commentId) => ({
  type: TRANSLATE_PARENT_REQUEST,
  payload: {
    commentId
  }
});

export const translateParentSuccess = ({ translatedComment, commentId }) => ({
  type: TRANSLATE_PARENT_SUCCESS,
  payload: {
    commentId,
    translatedComment
  }
});

export const translateParentFailure = (commentId) => ({
  type: TRANSLATE_PARENT_FAILURE,
  payload: {
    commentId
  }
});

export const translateChildRequest = ({ commentId, rootId }) => ({
  type: TRANSLATE_CHILD_REQUEST,
  payload: {
    commentId,
    rootId
  }
});

export const translateChildSuccess = ({
  translatedComment,
  rootId,
  commentId
}) => ({
  type: TRANSLATE_CHILD_SUCCESS,
  payload: {
    translatedComment,
    rootId,
    commentId
  }
});

export const translateChildFailure = ({ commentId, rootId }) => ({
  type: TRANSLATE_CHILD_FAILURE,
  payload: {
    commentId,
    rootId
  }
});

export const toggleParentTranslation = (commentId) => ({
  type: TOGGLE_PARENT_TRANSLATION,
  payload: {
    commentId
  }
});

export const toggleChildTranslation = ({ commentId, rootId }) => ({
  type: TOGGLE_CHILD_TRANSLATION,
  payload: {
    commentId,
    rootId
  }
});
